import React from 'react'
import { Icon } from '@mui/material'
import { Divider } from 'packages/eid-ui'
import { EmailIcon } from 'packages/eid-icons'
import GenericCard from './Cards/GenericCard'
import GenericCardHeader from './Cards/GenericCardHeader'
import GenericCardContent from './Cards/GenericCardContent'
import CardFieldGroup from './Cards/CardFieldGroup'
import CardField from './Cards/CardField'
import { useTranslation } from 'react-i18next'

const ContactCard = ({ contactInfo, handleModalOpen, config }) => {
    const { t } = useTranslation()
    return (
        <GenericCard
            onClick={config.editable ? handleModalOpen : undefined}
            editable={config.editable}
            showEditOption={config.showEditOption}
        >
            <GenericCardHeader
                backgroundColor="#fbfbfd"
                color="#b4b4b4"
                icon={
                    <Icon style={{ margin: '0.75em' }}>
                        <EmailIcon />
                    </Icon>
                }
                heading={t('Contact')}
                height={60}
            />
            <GenericCardContent>
                <CardField
                    label={t('Email')}
                    value={contactInfo.email}
                    wordWrap="anywhere"
                    borderBelow
                    singleField
                    link={`mailto:${contactInfo.email}`}
                />
                <CardFieldGroup>
                    <CardField
                        label={t('Telephone')}
                        value={contactInfo.telephone}
                        link={`tel:${contactInfo.telephone}`}
                    />
                    <Divider vertical width={23} />
                    <CardField
                        label={t('MobilePhone')}
                        value={contactInfo.mobilePhone}
                        link={`tel:${contactInfo.mobilePhone}`}
                    />
                </CardFieldGroup>
            </GenericCardContent>
        </GenericCard>
    )
}

export default ContactCard
